import styled from 'styled-components';
import Paper from '@material-ui/core/Paper';
import { Color } from '../../components/ThemeProvider/ThemeStyle';

export const Wrapper = styled(Paper)`
  min-width: 850px;
  .title {
    font-weight: 600;
    font-size: 18px;
    padding-bottom: 5px;
  }
  .left-info {
    width: 350px;
  }

  .st-error {
    background-color: ${Color.secondary};
    color: #fff;
    text-align: center;
    padding: 15px;
    margin-top: 30px;
    border-radius: ${Color.borderRadius};
    position: sticky;
    bottom: 0;
    border-top: 1px solid ${Color.border};
    z-index: 1;
    box-shadow: 0 -6px 6px -6px rgba(0, 0, 0, 0.16);
  }
`;

export const ButtonsWrapper = styled.div`
  position: sticky;
  bottom: 0;
  background-color: ${Color.bgColorPaper};
  padding: 5px 0;
  text-align: right;
  border-top: 1px solid ${Color.border};
  margin-top: 30px;
  z-index: 1;
  box-shadow: 0 -6px 6px -6px rgba(0, 0, 0, 0.16);
  > button {
    margin: 3px;
  }
`;

export const ErrorMessage = styled.div`
  color: ${Color.secondary};
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: pre-wrap;
`;
